<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Hekim"
    }
</script>

<style scoped>

</style>